import { BaseAPI } from "./BaseAPI";
import axios from "axios";
export class PaymentAPI extends BaseAPI {
  async startPayment({ email, clientName, illegalYear, autoNo, docNo }) {
    return axios
      .get(`${this._getContext()}/gov_pay`, {
        params: {
          email,
          clientName,
          illegalYear,
          autoNo,
          docNo,
        },
      })
      .then((res) => res.data);
  }

  async startGovPayment({ email, clientName, illegalYear, autoNo, docNo, expire, signature }) {
    return axios
      .get(`${this._getContext()}/mo/gov_pay/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}`, {
        params: {
          email,
          clientName,
          illegalYear,
          autoNo,
          docNo,
          expire,
          signature,
        },
      })
      .then((res) => res.data);
  }
}

export default new PaymentAPI();
